import { printNativeReceipt } from "./nativePrint";
import { useCallback, useEffect, useState } from "react";
import { Alert, CircularProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { printKioskReceipt } from "./printReceipt";

export default function KioskReceipt({ doctype, name, transport }) {
    const { i18n } = useTranslation();
    const ar = i18n.language?.startsWith("ar");
    const [status, setStatus] = useState("printing");
    const print = useCallback(async () => {
        setStatus("printing");
        try {
            if (transport === "Windows Service") {
                await printNativeReceipt({ doctype, name });
            } else { await printKioskReceipt({ doctype, name }); }
            setStatus("requested");
        }
        catch (error) { setStatus(error.printUnknown ? "unknown" : "error"); }
    }, [doctype, name, transport]);
    useEffect(() => { print(); }, [print]);
    useEffect(() => {
        if (status !== "printing") return;
        // The order is already saved. Slow receipt preparation or an offline
        // acknowledgement must not leave an indefinite loading indicator.
        const timer = setTimeout(() => setStatus("waiting"), 10000);
        return () => clearTimeout(timer);
    }, [status]);
    return <Stack spacing={1} alignItems="center">
        {status === "printing" && <><CircularProgress size={24} /><Typography>{ar ? "جارٍ تجهيز الإيصال للطباعة…" : "Preparing your receipt…"}</Typography></>}
        {status === "waiting" && <Typography role="status">{ar ? "طلبك محفوظ. جارٍ تأكيد الطباعة…" : "Your order is saved. Confirming receipt printing…"}</Typography>}
        {status === "unknown" && <Alert severity="warning">{ar ? "تعذّر تأكيد الطباعة. طلبك محفوظ." : "Printing could not be confirmed. Your order is saved."}</Alert>}
        {status === "error" && <Alert severity="warning">{ar ? "تعذّرت طباعة الإيصال. طلبك محفوظ." : "Unable to print the receipt. Your order is saved."}</Alert>}
        {status === "requested" && <Typography>{ar ? "يرجى أخذ الإيصال من الطابعة." : "Please collect your receipt."}</Typography>}
    </Stack>;
}
